import { render, staticRenderFns } from "./CreditNotes.vue?vue&type=template&id=79af1177&scoped=true"
import script from "./CreditNotes.vue?vue&type=script&lang=js"
export * from "./CreditNotes.vue?vue&type=script&lang=js"
import style0 from "./CreditNotes.vue?vue&type=style&index=0&id=79af1177&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af1177",
  null
  
)

export default component.exports